import React, { useCallback, useEffect } from 'react';
import styles from './overlay.module.scss';
import { classNames } from 'tradera/utils/class-names';

type OverlayProps = {
    children?: React.ReactChild;
    closeModalCallback?: () => void;
    className?: string;
    style?: React.CSSProperties;
};

export const Overlay = ({
    closeModalCallback,
    children,
    className,
    style
}: OverlayProps) => {
    const closeOnEscape = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                closeModalCallback?.();
            }
        },
        [closeModalCallback]
    );

    useEffect(() => {
        window.addEventListener('keydown', closeOnEscape);

        return () => {
            window.removeEventListener('keydown', closeOnEscape);
        };
    }, [closeOnEscape]);

    return (
        <div
            style={style}
            className={classNames(styles.overlay, className)}
            onClick={() => closeModalCallback?.()}>
            {children}
        </div>
    );
};
